import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles/styles.module.scss';
import cardStyles from '../CardContent/styles/styles.module.scss';
import CardName from '../CardName';
import ProBadgeSmall from '../../../../assets/images/icons/pro-badge-small.svg';
import UserImageLink from '../../shared/UserImageLink';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { formatUserLocation } from '../../../utils/user_helpers';

const TrailCompletedCard = ({ context, user }) => {
  const name = (
    <div className={cardStyles.nameTrailDetails}>
      {`${user.firstName} ${user.lastName}`}
      {user.pro && <img src={ProBadgeSmall} />}
    </div>
  );
  const location = formatUserLocation(user);
  const locationSpan = location != '' && <span className={`${styles.location} ${StringConstantsMixin.constants.XLATE.NONE}`}>{location}</span>;
  return (
    <div className={styles.container}>
      <UserImageLink className={cardStyles.inlineBlock} context={context} user={user} size48 />
      <CardName className={cardStyles.nameTrailDetails} name={name} />
      {locationSpan}
    </div>
  );
};

TrailCompletedCard.propTypes = {
  context: PropTypes.object,
  user: PropTypes.object.isRequired
};

export default TrailCompletedCard;
